<template>
  <div class="layout-page">
    <bottom></bottom>
    <download></download>
    <ios-home/>
    <div id="scroll-div-home" class="scroll-list aui-scrollView">
      <swiper v-if="pageInfo.adList.length > 0" :ad-list="pageInfo.adList"></swiper>
      <div class="search-word" style="background:#fff">
        <button @click="$router.push({name: 'book-search'})">{{getBookSearch.hotWords[0] || ''}}</button>
      </div>
      <template v-for="(item,index) in pageInfo.showcases">
        <template v-if="item.type == 'e_recommend'">
          <div class="divHeight" :key="index"></div>
          <books-normal
            :key="item.name"
            title="西瓜推荐"
            :books="item.books"
            @show-more="toRecommend(item, '西瓜推荐')"
          ></books-normal>
        </template>
        <template v-if="item.type == 'hot'">
          <div class="divHeight" :key="index"></div>
          <books-normal
            :key="item.name"
            title="人气榜单"
            :books="item.books"
            @show-more="toRecommend(item, '人气榜单')"
          ></books-normal>
        </template>
        <template v-if="item.type == 'kkbg'">
          <div class="divHeight" :key="index"></div>
          <books-normal
            :key="item.name"
            title="西瓜重磅"
            :books="item.books"
            @show-more="toRecommend(item, '西瓜重磅')"
          ></books-normal>
        </template>
        <template v-if="item.type == 'new_on'">
          <div class="divHeight" :key="index"></div>
          <books-small
            :key="item.name"
            title="西瓜新书"
            :books="item.books"
            @show-more="toRecommend(item, '西瓜新书')"
          ></books-small>
        </template>
        <template v-if="item.type == 'new'">
          <div class="divHeight" :key="index"></div>
          <books-large
            :key="item.name"
            title="每日更新"
            :books="item.books"
            @show-more="toRecommend(item, '每日更新')"
          ></books-large>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Swiper from '@/components/share/swiper'
import BooksNormal from '@/components/share/books-normal'
import BooksSmall from '@/components/share/books-small'
import BooksLarge from '@/components/share/books-large'
import Bottom from '@/components/layer1/bottom'
import Download from '@/components/layer1/download'
import iosHome from '@/components/layer1/iosHome'
import homeService from '../../services/homeService'
import shelfService from '../../services/shelfService'
import swiperService from '../../services/swiperService'

export default {
  name: 'home',
  data () {
    return {
      componentName: '',
      pageInfo: {
        adList: [],
        recommendList: [],
        showcases: []
      },
      historyList: []
    }
  },
  computed: {
    ...mapGetters(['getBookSearch', 'getHomeData'])
  },
  methods: {
    getIndexPage () {
      const { getHomeData } = this
      if (getHomeData) {
        this.pageInfo = getHomeData
        return
      }
      homeService
        .getIndexPage()
        .then(res => {
          const resData = res.data
          const adList = resData.adList || []
          this.pageInfo = resData
          swiperService.setAdList(adList)
          this.$store.commit('saveHomeData', resData)
          this.setHomeDataLocal(resData)
        })
        .catch(() => {
          this.$dialog.confirm({
            message: '网络超时，请刷新重试'
          }).then(() => {
            this.getIndexPage()
          })
        })
    },
    setHomeDataLocal (data = {}) {
      window.localStorage.setItem('$_home_data', JSON.stringify(data))
    },
    getHomeDataLocal () {
      try {
        let data = window.localStorage.getItem('$_home_data')
        if (data) {
          data = JSON.parse(data)
          this.pageInfo = data
        }
      } catch (error) {}
    },
    loadHistory () {
      this.historyList = shelfService
        .getHistory()
        .map(item => item.bookInfo)
        .splice(0, 3)
    },
    toRecommend (item, title) {
      this.$router.isBack = false
      this.$router.push({
        path: '/home/recommend',
        query: { type: item.type, name: title }
      })
    },
    toRanked () {
      this.$router.isBack = false
      this.$router.push('/home/ranked')
    },
    toLatest () {
      this.$router.isBack = false
      this.$router.push('/home/latest')
    },
    toRecent () {
      this.$router.isBack = false
      this.$router.push({ path: '/shelf', query: { active: 'history' } })
    }
  },
  components: {
    Download,
    iosHome,
    swiper: Swiper,
    'books-small': BooksSmall,
    'books-large': BooksLarge,
    BooksNormal,
    bottom: Bottom
  },
  created () {
    this.getHomeDataLocal()
  },
  mounted () {
    this.componentName = this.$route.name
    if (
      this.$store.state.pageState[this.componentName] &&
      this.$router.isBack
    ) {
      Object.assign(
        this.$data,
        this.$store.state.pageState[this.$route.name].data
      )
      setTimeout(() => {
        const scrollDiv = document.getElementById('scroll-div-home')
        scrollDiv.scrollTop = this.$store.state.pageState[this.$route.name].top
      }, 5)
    } else {
      this.getIndexPage()
      this.loadHistory()
    }
    this.$router.isBack = true
  },
  beforeDestroy () {
    this.$dialog.close()
    const scrollDiv = document.getElementById('scroll-div-home')
    const state = {}
    state[this.componentName] = { data: this.$data, top: scrollDiv.scrollTop }
    this.$store.commit('saveState', state)
  }
}
</script>

<style scoped>
</style>
